import { Chip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadQuickBooks } from '@sophocles/features/quickbooks/api';
import { selectQuickBooksAuthorizationUrl, selectQuickBooksCompany } from '@sophocles/features/quickbooks/slice';
import quickBooksIconUrl from '@sophocles/public/qbo-icon.png';

function QuickBooksChip({ onVerify }) {
  const dispatch = useDispatch();

  const quickBooksCompany = useSelector(selectQuickBooksCompany);
  const quickBooksAuthorizationUrl = useSelector(selectQuickBooksAuthorizationUrl);

  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (quickBooksAuthorizationUrl == null && quickBooksCompany == null) {
      setIsLoading(true);
      dispatch(loadQuickBooks())
        .unwrap()
        .then(response => {
          if (onVerify != null) {
            onVerify(true);
          }
        })
        .catch(e => {
          setHasError(true);
          if (onVerify != null) {
            onVerify(false);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  return (
    <Chip
      color={hasError ? 'error' : quickBooksCompany != null ? 'success' : 'primary'}
      onClick={() => {
        if (quickBooksAuthorizationUrl != null) {
          window.open(quickBooksAuthorizationUrl);
        }
      }}
      href={quickBooksAuthorizationUrl}
      disabled={isLoading || hasError || quickBooksAuthorizationUrl == null}
      label={
        isLoading ? 'Connecting' : quickBooksCompany != null ? 'Connected' : hasError ? 'Unavailable' : 'Authorize'
      }
      avatar={<img src={quickBooksIconUrl} style={{ maxHeight: '24px' }} alt="Quickbooks" />}
      size="lg"
    />
  );
}

export default QuickBooksChip;
